import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { api } from '../lib/api'
import Loading from '../ui/Loading'
import InlineError from '../ui/InlineError'
import { RoleLabels } from '../auth/rbac'

export default function SignupRequestDetailPage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [item, setItem] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const load = React.useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.get(`/signups/${id}`)
      const payload = res?.data?.data ?? res?.data
      setItem(payload)
    } catch (e) {
      setError('가입 신청 상세를 불러오지 못했습니다.')
    } finally {
      setLoading(false)
    }
  }, [id])

  useEffect(() => {
    load()
  }, [load])

  const handleDecision = async (action) => {
    const ok = window.confirm(action === 'approve' ? '해당 가입 신청을 승인하시겠습니까?' : '해당 가입 신청을 거절하시겠습니까?')
    if (!ok) return
    setLoading(true)
    setError(null)
    try {
      await api.post(`/signups/${id}/${action}`, {})
      navigate('/signups')
    } catch (e) {
      setError('처리에 실패했습니다.')
    } finally {
      setLoading(false)
    }
  }

  if (loading && !item) {
    return (
      <div className="py-8 flex justify-center">
        <Loading label="불러오는 중..." />
      </div>
    )
  }

  if (error && !item) {
    return <InlineError message={error} />
  }

  if (!item) {
    return null
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">가입 신청 상세 #{item.id}</h1>
        <div className="space-x-2">
          <button
            type="button"
            onClick={() => handleDecision('approve')}
            className="px-3 py-1 rounded bg-emerald-600 text-white text-sm"
          >
            승인
          </button>
          <button
            type="button"
            onClick={() => handleDecision('reject')}
            className="px-3 py-1 rounded bg-red-600 text-white text-sm"
          >
            거절
          </button>
        </div>
      </div>

      {error && <InlineError message={error} />}

      <div className="border rounded-md p-4 space-y-2 text-sm">
        <div><span className="font-semibold">이메일:</span> {item.email}</div>
        <div><span className="font-semibold">이름:</span> {item.name}</div>
        <div><span className="font-semibold">휴대폰:</span> {item.phoneNumber || '-'}</div>
        <div><span className="font-semibold">조직:</span> {item.orgName}</div>
        <div><span className="font-semibold">신청 역할:</span> {RoleLabels[item.requestedRole] || item.requestedRole}</div>
        <div><span className="font-semibold">상태:</span> {item.status}</div>
        <div><span className="font-semibold">신청일:</span> {item.createdAt ? new Date(item.createdAt).toLocaleString() : '-'}</div>
        <div><span className="font-semibold">처리일:</span> {item.decidedAt ? new Date(item.decidedAt).toLocaleString() : '-'}</div>
        <div><span className="font-semibold">처리자:</span> {item.decidedByName || '-'}</div>
        <div><span className="font-semibold">사유:</span> {item.decisionReason || '-'}</div>
      </div>
    </div>
  )
}


